import { Col, Row } from '@flos/react-ui';

import Graph from './components/Graph';
import OpeningHours from './components/OpeningHours';
import React from 'react';
import { getGraphAndTextsAndOpeningHours } from './helpers/graph-and-texts-and-opening-hours';
import { log } from './lib/logger';
import styles from './App.module.scss';

const App = ({ dateTime }: { dateTime: Date }) => {
    const data = getGraphAndTextsAndOpeningHours(dateTime);
    log('Data block:', data);

    const { graphTitle, graphText, graph, openingHoursTitle, openingHoursTitleSuffix, departments } = data;

    return (
        <>
            {window.debug && demoTimeSlots(data)}
            <Row className={styles.row}>
                <Col xs={12} md={8} className={styles.col}>
                    <Graph labelHeader={graphTitle} labelText={graphText} graph={graph} />
                </Col>
                <Col xs={12} md={4} className={styles.col}>
                    <OpeningHours
                        labelHeader={openingHoursTitle}
                        labelHeaderSuffix={openingHoursTitleSuffix}
                        departments={departments}
                    />
                </Col>
            </Row>
        </>
    );
};

// Used for adding easy time selectors while demoing and development
const demoTimeSlots = ({
    dayNameInUse,
    curTimeInUse,
    localDayName,
    localCurTime,
}: {
    dayNameInUse: string;
    curTimeInUse: number;
    localDayName: string;
    localCurTime: number;
}) => (
    <div style={{ textAlign: 'center', paddingTop: '10px' }}>
        <b>{dayNameInUse + ' ' + curTimeInUse}</b> <i>(local: {localDayName + ' ' + localCurTime})</i>
    </div>
);

export default App;
